import { fetchApi } from 'shared/functions';

export const addToScoringToolService = (id: string) => {
  const url = '/esg/api/esg-scoring-tool-add-item/';

  return fetchApi(url, { method: 'POST', body: JSON.stringify([id]) }).then(response =>
    response.json(),
  );
};
